import React, { Component } from 'react';
import { withFormik } from 'formik';
import Yup from 'yup';
import isEmpty from 'lodash/isEmpty'
import styled from 'styled-components';

import H2 from '../../collections/H2/H2';
import Paragraph from '../../collections/Paragraph/Paragraph';
import FormikForm from '../../components/Form/FormikForm';
import ButtonWrapper from '../../components/Form/ButtonWrapper';
import Button from '../../collections/Button/Button';

import ReactGA from 'react-ga';
import { fontUbuntu } from '../../utilities/utilities';

// import { DisplayFormikState } from '../../utilities/utilities';

const FormH2 = styled(H2)`
  align-self: flex-start;
  font-family: ${props => props.fontFamily ? props.fontFamily : fontUbuntu};
  font-weight:700;
`;

const IEParagraph = styled(Paragraph)`
  width:100%;
`;

const FormParagraph = styled(IEParagraph)`
  margin-top: 0.5rem;
  margin-bottom: 1rem;
`;

const InputField = styled.div`
  margin: 0;
  border: 0;
  display: inline-flex;
  padding: 0;
  position: relative;
  min-width: 0;
  margin: 1rem 0;
  align-items: center;
  background-color: #f7f7f7;
  width: 100%;
  border: 1px solid #ddd;
  padding: 1rem 1.5rem;
`;

const Checkbox = styled.input`
  transform: scale(1.5);
  
  @media only screen and (-webkit-min-device-pixel-ratio: 2),
  only screen and (   min--moz-device-pixel-ratio: 2),
  only screen and (     -o-min-device-pixel-ratio: 2/1),
  only screen and (        min-device-pixel-ratio: 2),
  only screen and (                min-resolution: 192dpi),
  only screen and (                min-resolution: 2dppx)
         {
             /* Resolution-specific CSS & images - retina displays*/
             width:64px;
             height:64px;
         }
  @media only screen and (-webkit-min-device-pixel-ratio: 1.25) and (min-device-width : 768px) and (max-device-width : 1024px),
         only screen and ( min--moz-device-pixel-ratio: 1.25) and (min-device-width : 768px) and (max-device-width : 1024px),
         only screen and ( -o-min-device-pixel-ratio: 1.25/1) and (min-device-width : 768px) and (max-device-width : 1024px),
         only screen and ( min-device-pixel-ratio: 1.25) and (min-device-width : 768px) and (max-device-width : 1024px),
         only screen and ( min-resolution: 200dpi) and (min-device-width : 768px) and (max-device-width : 1024px),
         only screen and ( min-resolution: 1.25dppx) and (min-device-width : 768px) and (max-device-width : 1024px)
         {
             /* Resolution-specific CSS & images - retina displays*/
             width:20px;
             height:20px;
         }
`;

const CheckboxLabel = styled.label`
  font-family: ${props => props.fontFamily ? props.fontFamily : fontUbuntu};
  color: ${props => props.textColor ? props.textColor : '#0d1b58'};
  font-size: 1rem;
  margin: 0 1rem;
  font-weight: 700;
  text-rendering: optimizeLegibility;
`;

class CardActivationForm extends Component {
  // constructor(props) {
  //   super(props);
  // };

  componentWillReceiveProps(nextProps) {
    let prompt = (this.props.isSubmitting === false);
    if (prompt !== this.props.form) {
      this.props.handleFormPrompt(prompt);
    }
  }

  sendEvent = (category, action, label) => {
      ReactGA.event({
          category: category,
          action: action,
          label: label
      })
  }

    generateURIFromCode = (code, path) => {
        let uri = ''
        let url = code.toLowerCase().split('_');
        if (url[0] === 'default') {
            uri = `/${path}`;
            return uri
        }
        if (url[0] === '') {
            uri = `/${path}`;
            return uri
        }
        if (url[1] !== undefined && url[1].length > 1) {
            uri = `/${url[0]}/${url[1]}/${path}`;
            return uri
        } else {
            uri = `/${url[0]}/${path}`;
            return uri
        }
    }

  render() {
    const {
      values,
      touched,
      errors,
      // dirty,
      isSubmitting,
      handleChange,
      handleBlur,
      // handleSubmit,
      // handleReset
    } = this.props;

    // const prompt = (isSubmitting === false);

    this.sendEvent('CardActivation', 'Journey', 'OptIn');

    return (
      <FormikForm>

        <FormH2 textColor={this.props.appState.ui.cardActivation.card.titleTextColor}>Cardholder special offers</FormH2>

        <FormParagraph textColor={this.props.appState.ui.cardActivation.card.titleTextColor} fontFamily={this.props.appState.ui.cardActivation.card.fontFamily}>We connect with a wide range of top retailers to bring you special discounts, deals and competitions, helping you get even more value from your card.</FormParagraph>

        <IEParagraph textColor={this.props.appState.ui.cardActivation.card.titleTextColor} fontFamily={this.props.appState.ui.cardActivation.card.fontFamily}>Opt into our exclusive cardholder emails to be the first to hear about these exciting offers. (You can unsubscribe at any point if you decide not to be kept up to date).</IEParagraph>

        <InputField>
          <Checkbox
            id="check"
            type="checkbox"
            value={values.check}
            checked={values.check}
            onChange={handleChange}
            onBlur={handleBlur}
            className={errors.check && touched.check ? 'text-input error' : 'text-input'}
          />
          <CheckboxLabel htmlFor="check" textColor={this.props.appState.ui.cardActivation.card.titleTextColor}>
            Please send me exclusive cardholder competitions, promotions and special offers by email
          </CheckboxLabel>
          { errors.check && touched.check && <div className="input-feedback">{errors.check}</div> }
        </InputField>

        <ButtonWrapper>
          <Button 
            color={this.props.appState.ui.cardActivation.buttons.backward.textColor} 
            background={this.props.appState.ui.cardActivation.buttons.backward.backgroundColor} 
            border={this.props.appState.ui.cardActivation.buttons.backward.borderColor} 
            type="button"
            role="button"
            onClick={this.props.backHandler}>
              {this.props.appState.ui.cardActivation.buttons.backward.text}
          </Button>
          <Button 
            color={this.props.appState.ui.cardActivation.buttons.forward.textColor} 
            background={this.props.appState.ui.cardActivation.buttons.forward.backgroundColor}
            border={this.props.appState.ui.cardActivation.buttons.forward.borderColor} 
            type="submit" 
            role="button"
            disabled={isSubmitting || !isEmpty(errors)}>
              {this.props.appState.ui.cardActivation.buttons.forward.text}
          </Button>
        </ButtonWrapper>

      </FormikForm>
    )
  }
};

const EnhancedForm = withFormik({
  mapPropsToValues: (props) => ({ 
    check: false
  }),

  validationSchema: Yup.object().shape({
    check: Yup.bool()
  }),

  handleSubmit: (values, { props, setSubmitting }) => {
    setSubmitting(true);
    props.handleErrorMessage(false, '');
    props.update({ loading: true }, (state) => {
      let sessionData = {
        ClientRef: state.cardDetails.ClientNumber,
        UserEmail: state.session.email,
        ExtranetSiteRules: JSON.stringify(state.siteRules),
        CommunicationSubscriptions: values.check ? state.cardDetails.CardTypeCode : null,
        TermsAcceptance: new Date(),
        TermsDocumentUrl: state.settings.terms,
        EComponentConfigurationTemplateId: state.cardDetails.EComponentTemplateId,
        CardSerialNumber: state.cardDetails.SerialNumber,
        MobileNumber: state.session.MobileNumber,
        CardType: state.cardDetails.CardTypeCode,
        NameOnCard: state.cardDetails.CHNameOnCard,
        CardStatus: state.cardDetails.CardStatus,
        CardBalance: state.cardDetails.Balance,
        CardActivationStartedOn: new Date(),
        CardActivationStatusId: 1,
        CreatedOn: new Date(),
      }

      setTimeout(() => {
        props.api.postSessionData(sessionData)
        .then(response => {
          props.update({
            session: response
          }, (state) => {
            props.api.getEComponentURL({CardSerialNumber: state.session.CardSerialNumber, Culture: 'en-gb'})
              .then(response => {
                props.update({
                  eComponentURL: response, 
                  loading: false
                }, () => {
                  props.nextHandler();
                });
              })
              .catch(error => {
                setSubmitting(false);
                props.handleErrorMessage(true, 'error getEComponentURL failed');
                props.update({loading: false});
              });
          });
        })
        .catch(error => {
          setSubmitting(false);
          props.handleErrorMessage(true, 'error postSessionData failed');
          props.update({loading: false});
        }) 
      }, 300);
      
    });

  },

  displayName: 'CardActivationStep2', // helps with React DevTools
})(CardActivationForm);


export default EnhancedForm;


// WEBPACK FOOTER //
// ./src/containers/CardActivationPage/Step2.js